import React from "react";
import styles from "./loader.scss";

const { visual, box_inside, shimmer_box, party_selector_loader } = styles;

const Loader = () => {
  return (
    <div className={party_selector_loader}>
      <div className={shimmer_box}>
        <div className={box_inside}>
          <span className={visual}></span>
          <span className={visual}></span>
          <span className={visual}></span>
          <span className={visual}></span>
          <span className={visual}></span>
          <span className={visual}></span>
          <span className={visual}></span>
          <span className={visual}></span>
        </div>
      </div>
    </div>
  );
};

export default Loader;
